import { type Theme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { SvgContainer } from './styled.ts';

export type BbfcR18Props = {
  height?: number;
  sx?: SystemStyleObject<Theme>;
  width?: number;
};

export const BbfcR18 = ({ height = 35, sx, width = 35 }: BbfcR18Props) => (
  <SvgContainer height={height} sx={sx} viewBox="0 0 92.604 92.604" width={width} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="a">
        <path d="M525 273h56.102v57H525Zm0 0" />
      </clipPath>
    </defs>
    <path
      d="M577.484 323.691a2.57 2.57 0 0 1-2.57 2.57H531.31a2.567 2.567 0 0 1-2.57-2.57v-43.605a2.57 2.57 0 0 1 2.57-2.57h43.605a2.572 2.572 0 0 1 2.57 2.57zm-2.57-48.761H531.31a5.161 5.161 0 0 0-5.157 5.156v43.605a5.161 5.161 0 0 0 5.157 5.157h43.605a5.164 5.164 0 0 0 5.156-5.157v-43.605a5.164 5.164 0 0 0-5.156-5.156"
      style={{
        fill: '#fff',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(1.6541 0 0 1.6541 -868.6 -453.057)"
    />
    <g clipPath="url(#a)" transform="matrix(1.6541 0 0 1.6541 -868.6 -453.057)">
      <path
        d="M580.07 323.691a5.164 5.164 0 0 1-5.156 5.157H531.31a5.161 5.161 0 0 1-5.157-5.157v-43.605a5.161 5.161 0 0 1 5.157-5.156h43.605a5.164 5.164 0 0 1 5.156 5.156zm-5.156-49.793H531.31c-3.414 0-6.192 2.778-6.192 6.188v43.605a6.198 6.198 0 0 0 6.192 6.192h43.605c3.41 0 6.188-2.778 6.188-6.192v-43.605a6.197 6.197 0 0 0-6.188-6.188"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
    </g>
    <path
      d="M574.914 277.516H531.31a2.57 2.57 0 0 0-2.57 2.57v43.605a2.567 2.567 0 0 0 2.57 2.57h43.605a2.57 2.57 0 0 0 2.57-2.57v-43.605a2.572 2.572 0 0 0-2.57-2.57"
      style={{
        fill: '#007dc7',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(1.6541 0 0 1.6541 -868.6 -453.057)"
    />
    <path
      d="M532.043 291.305h6.562c2.747.03 4.582.03 6.391 1.488 1.285 1.05 2.277 2.684 2.277 5.078 0 3.938-2.89 5.309-4.058 5.66l4.582 8.375h-4.406l-4.082-7.644h-3.446v7.644h-3.82zm3.82 3.328v6.449h1.344c1.313 0 1.809-.031 2.54-.059.843-.03 3.616-.175 3.616-3.18 0-.437-.03-1.956-1.633-2.773-.82-.406-1.812-.437-4.085-.437zM557.547 291.223v20.683h-3.77v-11.828c0-1.96 0-2.543-1.683-2.543h-3.371v-2.36h.398c1.93-.03 4.535-.058 5.363-3.952zM575.207 305.96c0 3.77-3.25 6.22-7.754 6.22-4.719 0-7.629-2.633-7.629-6.22 0-3.25 2.36-4.382 3.403-4.87-2.207-1.043-2.668-3.277-2.668-4.504 0-3.219 2.668-5.7 7.109-5.7 4.258 0 7.047 2.298 7.047 5.884 0 1.808-.735 3.37-2.695 4.32 2.39 1.195 3.187 2.973 3.187 4.87m-11.062-.12c0 1.746 1.226 2.941 3.492 2.941 1.992 0 3.465-1.043 3.465-2.972 0-.368-.063-2.942-3.465-2.942-3.278 0-3.492 2.328-3.492 2.973m.34-8.793c0 .918.394 2.726 3.183 2.726 2.422 0 3.035-1.566 3.035-2.726 0-2.36-1.871-2.79-3.066-2.79-2.602-.03-3.153 1.653-3.153 2.79"
      style={{
        fill: '#fff',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(1.6541 0 0 1.6541 -868.6 -453.057)"
    />
  </SvgContainer>
);
